/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module GfnupdaterTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Gfnupdater {
    [k: string]: any;
}
/**
 * This interface was referenced by `Gfnupdater`'s JSON-Schema
 * via the `definition` "UpdateStatusInfo".
 */
export interface UpdateStatusInfo {
    status: UpdateStatus;
    availableVersion?: string;
    severity?: Severity;
}
/**
 * This interface was referenced by `Gfnupdater`'s JSON-Schema
 * via the `definition` "InstallerStatus".
 */
export interface InstallerStatus {
    errorPresent: boolean;
    errorCode?: string;
    clientVersion?: string;
}
/**
 * This interface was referenced by `Gfnupdater`'s JSON-Schema
 * via the `definition` "GetUpdateCheckErrorStatusReturn".
 */
export interface GetUpdateCheckErrorStatusReturn {
    errorStatus: UpdateCheckErrorStatus;
}

/**
 * This interface was referenced by `Gfnupdater`'s JSON-Schema
 * via the `definition` "UpdateStatus".
 */
export enum UpdateStatus {
    NotAvailable = 'NotAvailable',
    CheckFailed = 'CheckFailed',
    PreparationStarted = 'PreparationStarted',
    PreparationFailed = 'PreparationFailed',
    ReadyToRelaunch = 'ReadyToRelaunch',
    CheckInProgress = 'CheckInProgress'
}
export enum Severity {
    recommended = 'recommended',
    required = 'required'
}
/**
 * This interface was referenced by `Gfnupdater`'s JSON-Schema
 * via the `definition` "UpdateCheckErrorStatus".
 */
export enum UpdateCheckErrorStatus {
    NoError = 'NoError',
    UpdateCheckFailureThresholdReached = 'UpdateCheckFailureThresholdReached',
    DownloadPrepareFailureThresholdReached = 'DownloadPrepareFailureThresholdReached'
}


}
